import React, { useState, useEffect } from 'react';
import { ModalWrapper, ButtonGroup } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Space, Table, Form, Input , Button, Popconfirm, message, Select, InputNumber } from 'antd';
import { DatePicker, CompanySelectBox } from 'components/atoms'
import { useBillRequestB2CDetail, useRefCode } from 'hooks';
import { TableWrapper } from 'components/molecules';
import { ColumnsType } from 'antd/lib/table/interface';
import moment, { Moment } from 'moment';
import { CheckOutlined } from '@ant-design/icons';
import { dateFormat } from 'utils/date-utils';
import { IMaskInput } from "react-imask";

export interface BillB2CRequestModalModalProps extends PopupProps {
    id: number;
    student_id: number;
}

const BillB2CRequestModal = ({ isOpen, onClose, id, student_id }: BillB2CRequestModalModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    
  const [companySrl, setCompanySrl] = useState<number>(0);
  const [companyPoint, setCompanyPoint] = useState<number>(0);
  const [companyMoney, setCompanyMoney] = useState<number>(0);
  const [requestList, setRequestList] = useState<BillItemB2CInfoDto[]>([]);
  const [selected, setSelected] = useState<BillItemB2CInfoDto[]>([]);
  const [billPrice, setBillPrice] = useState<number>(0);
  const [publicCompany, setPublicCompany] = useState<string>('Y');

   /* ======================================================
   * variables
   * ====================================================== */
   const [form] = Form.useForm();
   const { TextArea } = Input;

   const columns: ColumnsType<BillItemB2CInfoDto> = [
    {
      title: '회사명',
      dataIndex: 'company',
      key: 'company',
      width: '100px',
      align: 'left',
      ellipsis: true,
    },
    {
     title: '교육생명',
     dataIndex: 'name_kor',
     key: 'name_kor',
     width: '80px',
     align: 'center',
     ellipsis: true,
   },   
   {
    title: '담당자명',
    dataIndex: 'acc_name',
    key: 'acc_name',
    width: '80px',
    align: 'center',
    ellipsis: true,
  },     
  {
    title: '담당자핸드폰',
    dataIndex: 'acc_phone',
    key: 'acc_phone',
    width: '100px',
    align: 'center',
    ellipsis: true,
  },  
  {
    title: '담당자이메일',
    dataIndex: 'acc_email',
    key: 'acc_email',
    width: 'auto',
    align: 'center',
    ellipsis: true,
  },   
   {
    title: '교육비',
    dataIndex: 'mem_price',
    key: 'mem_price',
    width: '80px',
    align: 'right',
    ellipsis: true,
    render: (mem_price, record) => {
      return (
        mem_price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      )
    }      
  },  
  {
    title: '결제수단',
    dataIndex: 'ebill_yn',
    key: 'ebill_yn',
    width: '120px',
    align: 'center',
    ellipsis: true,
    render: (ebill_yn, record) => {
      return (
        ebill_yn==='Y'?'세금계산서':(ebill_yn==='C')?'선납금':(ebill_yn==='N')?'카드':(ebill_yn==='P')?'포인트':'현금영수증'
      )
    } 
  },  
  {
    title: '결제메모',
    dataIndex: 'ebill_etc',
    key: 'ebill_etc',
    width: '100px',
    align: 'left',
    ellipsis: true,
  },
  {
    title: '발행금액',
    dataIndex: 'no_bill_price',
    key: 'no_bill_price',
    width: '120px',
    align: 'right',
    ellipsis: true,
    render: (no_bill_price, record, index) => {
      const select = selected.find((item) => item.key === record.key);
      return (
        (select && no_bill_price>0)?(
          <IMaskInput 
            min={0} 
            max={record.no_bill_price} 
            mask = {Number}
            thousandsSeparator={','}
            defaultValue={record.no_bill_price}
            className={'ant-input'} 
            unmask={'typed'} 
            onAccept = {((value, mask) => onInputChange("bill_price", index, value))}
            />                
        ):(
          no_bill_price && no_bill_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        )
      )
      }
  }, 
  ];
   /* ======================================================
   * events
   * ====================================================== */
   
  const onCloseCancle = () => {
    onClose?.(false); 
  }  

  const onInsert = () => {

    let items = ''
    selected.forEach((select) => {
      const find = requestList.find((item) => item.key === select.key && item.bill_price > 0);
      if (!!find) {
        if (items.length > 0) items += ',';
        items += find.key + '_' + find.bill_price;
      }
    });

    if (form.getFieldValue("bill_type") === 'point' && companyPoint < (billPrice*1.1)) {
      message.error('포인트가 부족합니다.', 1);
    } else if (form.getFieldValue("bill_type") === 'prepay' && companyMoney < billPrice) {
      message.error('선납금이 부족합니다.', 1);
    } else if (items.length > 0) {
      const data = {
        id: 0,
        bill_group: 'b2c',
        bill_type: form.getFieldValue("bill_type"),
        bill_day: form.getFieldValue("bill_day") ? dateFormat(form.getFieldValue("bill_day"), 'YYYY-MM-DD'):'null',
        group_srl: id,
        group_name: billInfo?.group_name,
        public_company: form.getFieldValue("public_company"),
        company_srl: form.getFieldValue("company_srl"),
        acc_name: form.getFieldValue("acc_name"),
        acc_phone: form.getFieldValue("acc_phone"),
        acc_email: form.getFieldValue("acc_email"),
        bill_price: billPrice,
        memo: form.getFieldValue("memo"),
        items: items,
      }

      billInsert(data) 
    }

  }

  const onInputChange = (key, index, value) => {
    const newData = [...requestList];
    setBillPrice(billPrice + (Number(value) - newData[index][key])); 
    newData[index][key] = Number(value);
    setRequestList(newData);
  };

  const rowSelection = {
    defaultSelectedRowKeys: ['C_'+student_id],
    onChange: (selectedRowKeys: React.Key[], selectedRows: BillItemB2CInfoDto[]) => {
      let price = 0;
      requestList.forEach((item) => {
        const find = selectedRows.find((select) => item.key === select.key)
        if (!!find) {
          if (item.bill_price === 0) item.bill_price = find.no_bill_price;
          price += item.no_bill_price || 0;

          if (!!item.company_srl) {
            setCompanySrl(item.company_srl);
            form.setFieldValue('company_srl', item.company_srl);
            form.setFieldValue('acc_name', item.acc_name);
            form.setFieldValue('acc_phone', item.acc_phone);
            form.setFieldValue('acc_email', item.acc_email);
          }          
        } else {
          item.bill_price = 0;
        }        
      });

      setBillPrice(price);
      setSelected(selectedRows);           
    },

    getCheckboxProps: (record: BillItemB2CInfoDto) => ({
      disabled: (0 === record.no_bill_price), // Column configuration not to be checked
    }),
  };
  /* ======================================================
   * hooks
   * ====================================================== */
  const { billInfo, billItems, insertSuccess, billInsert } = useBillRequestB2CDetail(id); 
  const { refCodeList: billType } = useRefCode({field:'bill_type', status_type: 'AV'});   

  /* ======================================================
   * effects
   * ====================================================== */

  useEffect(() => {
    if (!!billInfo) {
      form.setFieldsValue({
          bill_type: 'tex',
          bill_day: (!!billInfo.bill_day && billInfo.bill_day !== '0000-00-00') ? moment(billInfo.bill_day, "YYYY-MM-DD") : undefined,
          acc_name: billInfo.acc_name,
          acc_phone: billInfo.acc_phone,
          acc_email: billInfo.acc_email,
          company_srl: billInfo.company_srl, 
          memo: billInfo.memo, 
          public_company: 'Y',
      });
      setCompanySrl(billInfo.company_srl);
    }     
  }, [billInfo])

  useEffect(() => {
    if (!!billItems) {    

      if (student_id > 0) {
        const find = billItems.find((item) => item.key === 'C_'+student_id)
        if (!!find) {
          find.bill_price = find.no_bill_price;
          if (!!find.company_srl) {
            setCompanySrl(find.company_srl);
            form.setFieldValue('company_srl', find.company_srl);
            form.setFieldValue('acc_name', find.acc_name);
            form.setFieldValue('acc_phone', find.acc_phone);
            form.setFieldValue('acc_email', find.acc_email);
          } 
          
          setBillPrice(find.no_bill_price);
          setSelected([find]); 
        }  
      }

      setRequestList(billItems); 
    }     
  }, [billItems])

  useEffect(() => {
    if (insertSuccess)
    onClose?.(true);     
  }, [insertSuccess])  

  useEffect(() => {
      form.setFieldValue("bill_type", "tex");
  }, [publicCompany])  
    return (
      <ModalWrapper open={isOpen} onCancel={onCloseCancle} width={1050} title={'계산서 발행 요청서'} closable>
          <Space direction="vertical" style={{ width: '100%' }}>
          <label ><CheckOutlined /> 발행 대상 선택&nbsp;&nbsp;&nbsp;* 계산서 발행할 교육생을 아래 목록에서 선택하세요.</label>
          <TableWrapper isSearch={false}>
                  <Table
                      tableLayout="fixed"
                      dataSource={requestList}
                      pagination={false}
                      columns={columns}
                      style={{ width: '100%', overflowX: 'auto', minWidth: 600 }}
                      showSorterTooltip={false}
                      scroll={{ y: 240 }}
                      rowKey={'key'}
                      rowSelection={{
                        type: 'checkbox',
                        ...rowSelection
                      }}
                  />
              </TableWrapper>
              <div style={{float:"right"}}>
                <label>발행금액: {billPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}원 (vat 포함: {(billPrice*1.1).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")})</label>
              </div>
          <Form
                  form={form}
                  name="RefCode"
                  layout="horizontal"  
                  labelCol={{ flex: '100px' }}
                  style={{width:'100%', marginBottom:'20px'}}
              >
                  <Form.Item label={'과정명'}>
                    <label>{billInfo?.group_name}</label>
                  </Form.Item>  
                  <Form.Item name="bill_type" label={'발행구분'}>
                  {(publicCompany === 'Y') ? (
                    <Select 
                    placeholder="발행구분 선택" 
                    style={{width:"150px"}}>
                    {billType?.map((item) => {
                        return (<Select.Option key={item.name} value={item.name}>{item.value}</Select.Option>)
                    })}                        
                    </Select>  
                  ):(
                    <Select 
                      placeholder="발행구분 선택" 
                      style={{width:"150px"}}
                      options={[{label:'세금계산서', value:'tex'}, {label:'현금영수증', value:'cash'}, {label:'카드', value:'card'}]}
                      />  
                  )}

                  </Form.Item> 
                  <Form.Item name="public_company" label={'발행형태'}>
                    <Select 
                      placeholder="발행형태 선택" 
                      style={{width:"150px"}}
                      defaultValue={publicCompany}
                      options={[{label:'회사', value:'Y'},{label:'개인', value:'N'}]}
                      onChange={(value) => setPublicCompany(value)}
                    />
                  </Form.Item> 
                  {(publicCompany === 'Y') && (
                    <>
                    <Form.Item label={'고객사'}>
                      <CompanySelectBox required={false} form={form} company_srl={companySrl} onSelected={(value, option) => { setCompanySrl(Number(value)); setCompanyMoney(option.money); setCompanyPoint(option.point)}} view_info/>
                    </Form.Item>   
                    <Form.Item label={'결제담당자'}>
                      <label style={{ display: 'inline-block', padding: '5px' }}>이름 : </label>
                      <Form.Item name={'acc_name'}  style={{ width:'100px', display: 'inline-block', marginRight: '10px' }}>
                        <Input />  
                      </Form.Item>
                      <label style={{ display: 'inline-block', padding: '5px' }}>전화번호 : </label>
                      <Form.Item name={'acc_phone'}  style={{ width:'120px', display: 'inline-block', marginRight: '10px' }}>
                        <Input />  
                      </Form.Item>
                      <label style={{ display: 'inline-block', padding: '5px' }}>이메일 : </label>
                      <Form.Item name={'acc_email'}  style={{ width:'200px', display: 'inline-block', marginRight: '10px' }}>
                        <Input />  
                      </Form.Item>
                    </Form.Item>  
                    </>
                  )}                 
                  <Form.Item name="bill_day" label={'발행일'}>
                    <DatePicker showTime={false} format="YYYY-MM-DD" />      
                  </Form.Item>    
                  <Form.Item name='memo' label={'메모'}>
                      <TextArea rows={2} placeholder='일정 메모를 입력하세요'/>   
                  </Form.Item>                                                             
              </Form> 
            <ButtonGroup className={'buttonsWrapper'}>
              <Button onClick={()=>{onClose?.(false)}}>취소</Button>
              <Button onClick={onInsert} disabled={selected.length === 0 || billPrice === 0}>신청</Button>
            </ButtonGroup>  

          </Space>     
      </ModalWrapper>  
    )    
};

export default React.memo(BillB2CRequestModal);    